import Backbone from 'backbone';

/*/ ## EF.Collections.AnswersCollection
//
// Collection for the possible answers to survey questions. */
const AnswersCollection = Backbone.Collection.extend({});

export default AnswersCollection;
